var Tile = require("./tile");
var Mappers = require("./mappers");

// CRC-32 (IEEE), used only to recognise the handful of PAL-only cartridges
// whose old iNES headers leave both TV-system fields at zero. The PRG CRC is
// header independent, so the same game dumped as iNES 1.0 or NES 2.0 matches.
var CRC32_TABLE = (function () {
  var table = new Array(256);
  for (var n = 0; n < 256; n++) {
    var c = n;
    for (var k = 0; k < 8; k++) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    table[n] = c >>> 0;
  }
  return table;
})();

function crc32(bytes) {
  var crc = 0xffffffff;
  for (var i = 0; i < bytes.length; i++) {
    crc = CRC32_TABLE[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
}

// PAL-only games whose legacy headers claim NTSC. Asterix (Europe) ships in
// two dumps with different headers but identical PRG; both time their vblank
// work for a 312-line frame.
var KNOWN_PAL_PRG_CRC32 = {
  0xed77b453: "Asterix (Europe)",
};

// Name table mirroring modes. These values are shared with the PPU, which owns
// the actual address mapping; the mappers only select one of these constants.
var MIRRORING_TYPES = {
  VERTICAL: 0,
  HORIZONTAL: 1,
  SINGLE_SCREEN: 2,
  SINGLE_SCREEN_ALT: 3,
  FOUR_SCREEN: 4,
};

// Human readable names, used by the status line and the UI.
var MAPPER_NAMES = {
  0: "NROM",
  1: "MMC1",
  2: "UNROM",
  3: "CNROM",
  4: "MMC3",
  5: "MMC5",
  6: "FFE F4xxx",
  7: "AxROM",
  8: "MROM (32kB switch)",
  9: "MMC2",
  10: "MMC4",
  11: "Color Dreams",
  12: "MMC3 (partial)",
  15: "Multicart",
  16: "Bandai FCG (LZ93D50)",
  153: "Bandai FCG + 8 KB WRAM",
  159: "Bandai FCG + X24C01",
  18: "Jaleco NSF",
  19: "Namco 163",
  20: "FDS",
  21: "VRC4a/VRC4c",
  22: "VRC2a",
  23: "VRC2b/VRC4e",
  24: "VRC6a",
  25: "VRC6b",
  26: "VRC6b alt",
  30: "MMC6",
  31: "RxROM",
  32: "MMC1 (32kB)",
  34: "BNROM",
  37: "MMC3 (PAL-ZZ)",
  38: "UNROM variant",
  40: "LDROM",
  41: "MMC1 (Columbus)",
  42: "MMC3 (submapper)",
  43: "MMC2 (submapper)",
  44: "MMC3 (MMC6-like)",
  45: "MMC1 (submapper)",
  46: "MMC1 (submapper)",
  47: "MMC3 (NES-QJ)",
  48: "MMC1 (submapper)",
  62: "Super 700-in-1",
  49: "MMC3 (submapper)",
  65: "Irem H-3001",
  66: "GxROM",
  67: "Sunsoft-3",
  69: "Sunsoft FME-7",
  70: "Camera (Fire Hawk)",
  71: "Codemasters",
  72: "Camera (Super Block)",
  73: "VRC3",
  74: "MMC3 (Jaleco)",
  75: "MMC1 (Jaleco)",
  76: "MMC3 (MMC6)",
  77: "MMC1 (submapper)",
  78: "MMC3 (submapper)",
  79: "NINA-003/006/007/008",
  80: "MMC3 (submapper)",
  82: "MMC3 (submapper)",
  83: "MMC3 (submapper)",
  84: "MMC3 (submapper)",
  85: "VRC7",
  86: "MMC2 (submapper)",
  87: "J87",
  88: "MMC1 (Zaxxon)",
  89: "MMC1 (submapper)",
  90: "J.Y. Company ASIC",
  35: "J.Y. Company (WRAM)",
  36: "TXC 01-22000-400",
  91: "JY Company",
  92: "Jaleco JJ-TC001",
  93: "MMC3 (submapper)",
  94: "UN1ROM",
  95: "MMC1 (submapper)",
  96: "MMC3 (submapper)",
  97: "MMC1 (submapper)",
  102: "MMC1",
  104: "MMC1",
  105: "MMC1",
  106: "MMC1",
  107: "MMC1",
  112: "MMC3",
  114: "MMC3",
  115: "MMC3",
  118: "TxSROM",
  119: "MMC3 (TQROM)",
  122: "MMC3",
  138: "MMC3 (submapper)",
  140: "Jaleco JF-14",
  141: "Jaleco JF-14",
  142: "MMC3 (submapper)",
  143: "MMC3 (submapper)",
  144: "MMC3 (submapper)",
  145: "MMC3 (submapper)",
  146: "MMC3 (submapper)",
  148: "MMC3 (submapper)",
  149: "MMC3 (submapper)",
  150: "MMC3 (submapper)",
  151: "MMC3 (submapper)",
  152: "MMC1",
  154: "MMC3 (submapper)",
  157: "MMC3 (submapper)",
  180: "UNROM variant",
  184: "MMC3 (submapper)",
  185: "MMC3 (submapper)",
  186: "MMC3 (submapper)",
  187: "MMC3 (submapper)",
  189: "MMC3 (submapper)",
  190: "MMC3 (submapper)",
  193: "Color Dreams",
  196: "MMC3 (submapper)",
  198: "MMC1 (submapper)",
  199: "MMC3 (submapper)",
  205: "MMC3 (JC-016-2)",
  210: "MMC3 (submapper)",
  211: "MMC3 (submapper)",
  212: "MMC3 (submapper)",
  213: "MMC3 (submapper)",
  214: "MMC3 (submapper)",
  215: "MMC3 (submapper)",
  216: "MMC3 (submapper)",
  217: "MMC3 (submapper)",
  218: "MMC3 (submapper)",
  228: "Action 52",
  232: "VRC4",
};

function ROM(nes) {
  this.nes = nes;

  this.header = null;
  this.rom = [];
  this.vrom = [];
  this.vromTile = [];

  this.romCount = 0;
  this.vromCount = 0;
  this.mapperType = 0;

  // Video system requested by the header (or by the known-PAL fallback). The
  // NES uses this to pick the frame geometry; it is not the same thing as the
  // user's explicit `pal` option.
  this.isPal = false;
  this.prgCrc32 = 0;

  this.mirroring = MIRRORING_TYPES.VERTICAL;
  this.batteryRam = false;
  this.batteryRamData = null;
  this.trainer = false;
  this.fourScreen = false;

  // Famicom Disk System images (.fds) carry no iNES banks at all: they are a
  // handful of 65500-byte disk sides that mapper 20 feeds to the BIOS through
  // the disk drive registers. `isFds` is what tells the mapper and the UI
  // apart from a cartridge.
  this.isFds = false;
  this.fdsSides = [];

  this.valid = false;
}

// "FDS" followed by the DOS end-of-file byte: the 16-byte fwNES .fds header.
var FDS_MAGIC = [0x46, 0x44, 0x53, 0x1a];

// One side of a disk, in the fwNES .fds format. The last side may be short on
// a truncated dump, so readers always pad to this.
ROM.FDS_SIDE_SIZE = 65500;

ROM.MIRRORING_TYPES = MIRRORING_TYPES;

ROM.prototype.VERTICAL_MIRRORING = MIRRORING_TYPES.VERTICAL;
ROM.prototype.HORIZONTAL_MIRRORING = MIRRORING_TYPES.HORIZONTAL;
ROM.prototype.SINGLESCREEN_MIRRORING = MIRRORING_TYPES.SINGLE_SCREEN;
ROM.prototype.SINGLESCREEN_MIRRORING2 = MIRRORING_TYPES.SINGLE_SCREEN_ALT;
ROM.prototype.FOURSCREEN_MIRRORING = MIRRORING_TYPES.FOUR_SCREEN;

// Instances the mapper declared in the header. Throws when the board is not
// implemented, so a caller can report an unsupported ROM instead of silently
// running the wrong bank layout. The registry's own fallback to NROM never gets
// a chance to hide here, because the support check comes first.
ROM.prototype.createMapper = function () {
  if (!Mappers._known(this.mapperType)) {
    throw new Error("Mapper not implemented: " + this.mapperType);
  }
  var MapperClass = Mappers._load(this.mapperType);
  var mapper = new MapperClass(this.nes);
  return mapper;
};

ROM.prototype.mapperSupported = function () {
  return Mappers._known(this.mapperType);
};

ROM.prototype.getMapperName = function () {
  return MAPPER_NAMES[this.mapperType] || "Mapper " + this.mapperType;
};

// Mirroring requested by the cartridge header, as a PPU mirroring constant.
ROM.prototype.getMirroringType = function () {
  if (this.fourScreen) {
    return MIRRORING_TYPES.FOUR_SCREEN;
  }
  return this.mirroring === MIRRORING_TYPES.HORIZONTAL
    ? MIRRORING_TYPES.HORIZONTAL
    : MIRRORING_TYPES.VERTICAL;
};

ROM.prototype.getBatteryRam = function () {
  return this.batteryRamData;
};

ROM.prototype.setBatteryRam = function (data) {
  this.batteryRamData = data;
};

// Converts any of the shapes the front end may hand us into a byte array.
ROM.prototype.toByteArray = function (data) {
  if (typeof data === "string") {
    var fromString = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
      fromString[i] = data.charCodeAt(i) & 0xff;
    }
    return fromString;
  }
  if (data instanceof Uint8Array) {
    return data;
  }
  if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  }
  if (ArrayBuffer.isView(data)) {
    return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  }
  if (Array.isArray(data)) {
    return new Uint8Array(data);
  }
  throw new Error("Unsupported ROM data type.");
};

// The fwNES .fds container: an optional 16-byte header ("FDS\x1a", side count,
// zero padding) followed by whole 65500-byte sides. Headerless dumps exist, in
// which case the sides are the whole file and the count is derived from the
// length.
ROM.isFdsImage = function (bytes) {
  if (
    bytes.length >= 16 &&
    bytes[0] === FDS_MAGIC[0] &&
    bytes[1] === FDS_MAGIC[1] &&
    bytes[2] === FDS_MAGIC[2] &&
    bytes[3] === FDS_MAGIC[3]
  ) {
    return true;
  }
  // No header: only claim the file when it is a whole number of sides. A random
  // file this long is not something the other loaders would have accepted
  // either (they want the iNES magic).
  return (
    bytes.length >= ROM.FDS_SIDE_SIZE && bytes.length % ROM.FDS_SIDE_SIZE === 0
  );
};

// Parses a .fds image into `fdsSides`, one Uint8Array(65500) per disk side, and
// leaves the ROM object in the shape the rest of the emulator expects from a
// cartridge: mapper 20, no PRG/CHR banks (the BIOS comes from the RAM adaptor,
// the pattern tables are RAM), and a synthetic iNES header so the tools and the
// debug panel keep working.
ROM.prototype.loadFds = function (bytes) {
  var offset = 0;
  var declared = 0;

  if (
    bytes.length >= 16 &&
    bytes[0] === FDS_MAGIC[0] &&
    bytes[1] === FDS_MAGIC[1] &&
    bytes[2] === FDS_MAGIC[2] &&
    bytes[3] === FDS_MAGIC[3]
  ) {
    declared = bytes[4];
    offset = 16;
  }

  var available = Math.floor((bytes.length - offset) / ROM.FDS_SIDE_SIZE);
  var sides = declared > 0 ? declared : available;

  if (sides < 1 || available < 1) {
    throw new Error(
      "Not a valid FDS image. Expected at least one 65500-byte disk side.",
    );
  }
  if (available < sides) {
    // A header can lie, and truncated dumps are common. Emulate what is there
    // rather than refusing the whole image; the BIOS reports the unreadable
    // side by itself.
    sides = available;
  }

  this.fdsSides = [];
  for (var s = 0; s < sides; s++) {
    var start = offset + s * ROM.FDS_SIDE_SIZE;
    var side = new Uint8Array(ROM.FDS_SIDE_SIZE);
    side.set(bytes.subarray(start, start + ROM.FDS_SIDE_SIZE));
    this.fdsSides.push(side);
  }

  this.isFds = true;
  this.header = [
    0x4e,
    0x45,
    0x53,
    0x1a,
    0,
    0,
    0x40 | 1,
    0x10,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
  ];
  this.rom = [];
  this.vrom = [];
  this.vromTile = [];
  this.romCount = 0;
  this.vromCount = 0;
  this.mapperType = 20;
  this.mirroring = MIRRORING_TYPES.VERTICAL;
  this.batteryRam = false;
  this.batteryRamData = null;
  this.trainer = false;
  this.trainerData = null;
  this.fourScreen = false;
  this.valid = true;
};

ROM.prototype.load = function (data) {
  var bytes = this.toByteArray(data);
  var i, v;

  if (bytes.length < 16) {
    throw new Error("Not a valid NES ROM. File is too small.");
  }

  // A .fds image is not an iNES cartridge: no magic "NES\x1a", no banks, just
  // one or more 65500-byte disk sides. It was upstream's `bytes[8..15] !== 0`
  // heuristic that used to be the only FDS handling here; a real image does not
  // even reach the mapper table.
  if (ROM.isFdsImage(bytes)) {
    this.loadFds(bytes);
    return;
  }

  var magic = [0x4e, 0x45, 0x53, 0x1a];
  for (i = 0; i < 4; i++) {
    if (bytes[i] !== magic[i]) {
      throw new Error("Not a valid NES ROM. Bad iNES magic.");
    }
  }

  this.header = [];
  for (i = 0; i < 16; i++) {
    this.header[i] = bytes[i];
  }

  this.romCount = this.header[4];
  this.vromCount = this.header[5] * 2;
  // iNES flags 6 bit 0: 0 = horizontal, 1 = vertical. Horizontal means the two
  // name tables sit side by side, so $2000/$2400 read the same page and
  // $2800/$2C00 read the other -- ppu.ntable1 becomes [0,0,1,1].
  //
  // This had the two the wrong way round, which swapped the arrangement for every
  // game that relies on the header rather than writing a mirroring register. The
  // two halves of a side-by-side status bar would come from different pages, and a
  // vertical game would show its two columns where its two rows should be.
  this.mirroring =
    (this.header[6] & 1) !== 0
      ? MIRRORING_TYPES.VERTICAL
      : MIRRORING_TYPES.HORIZONTAL;
  this.batteryRam = (this.header[6] & 2) !== 0;
  this.trainer = (this.header[6] & 4) !== 0;
  this.fourScreen = (this.header[6] & 8) !== 0;
  // Mapper: low nibble in header[6] bits 4-7, high nibble in header[7] bits 4-7
  // (the iNES spec). The high nibble used to be read from header[7] bits 0-3,
  // which are the console-type bits: any ROM whose mapper needs the high nibble
  // came up as a different board entirely -- Batman - Return of the Joker
  // (mapper 69) loaded as MMC5, Alien Syndrome (mapper 118) as mapper 6 --
  // while main.js, which parses the same header correctly, announced the right
  // number. romBuilder wrote the nibble the same wrong way, so the synthetic
  // tests agreed with the bug and could not see it.
  this.mapperType = ((this.header[6] >> 4) & 0x0f) | (this.header[7] & 0xf0);

  // TV system. NES 2.0 keeps it in byte 12; legacy iNES put it in byte 9 bit 0
  // and/or byte 10 bits 0-1. Old dumping tools often left those bytes zero on
  // PAL-only carts (Asterix is the one that made this visible), so the known
  // PRG CRC table below covers the important leftovers.
  if ((this.header[7] & 0x0c) === 0x08) {
    this.isPal = (this.header[12] & 0x03) === 0x01;
  } else if ((this.header[10] & 0x03) === 0x01) {
    this.isPal = true;
  } else if (
    (this.header[9] & 0x01) !== 0 &&
    (this.header[9] & 0xfe) === 0 &&
    (this.header[10] & 0x03) === 0
  ) {
    this.isPal = true;
  }

  // Bytes 8-15 are zero on plain iNES images. When they are not, the file might be
  // an FDS image (which has an odd number of PRG banks) or a homebrew extension.
  // Only truncate the mapper if it's clearly an FDS image (odd PRG bank count).
  // Many valid cartridge conversions have non-zero bytes 8-15 from dumping tools
  // or VS System/PlayChoice-10 headers, so we only truncate for clear FDS images.
  if (this.romCount & 1) {
    // FDS images have an odd number of 16 KB PRG banks (typically 1)
    this.mapperType &= 0x0f;
  }

  var offset = 16;

  // The 512 byte trainer sits between the header and the PRG data, and has to
  // land at $7000 in the CPU address space.
  this.trainerData = this.trainer
    ? bytes.subarray(offset, Math.min(offset + 512, bytes.length))
    : null;
  if (this.trainer) {
    offset += 512;
  }

  if (this.romCount === 0) {
    // Some ROMs declare zero PRG banks and still expect a 16 KB image.
    if (bytes.length - offset < 16384) {
      throw new Error("Not a valid NES ROM. No PRG data.");
    }
    this.romCount = 1;
  }

  if (bytes.length - offset < this.romCount * 16384) {
    throw new Error(
      "Not a valid NES ROM. Expected " +
        this.romCount * 16384 +
        " bytes of PRG data, found " +
        (bytes.length - offset) +
        ".",
    );
  }

  // PRG-ROM, split into 16 KB banks.
  var prgOffset = offset;
  this.rom = [];
  for (i = 0; i < this.romCount; i++) {
    this.rom.push(bytes.subarray(offset, offset + 16384));
    offset += 16384;
  }
  this.prgCrc32 = crc32(
    bytes.subarray(prgOffset, prgOffset + this.romCount * 16384),
  );
  if (KNOWN_PAL_PRG_CRC32[this.prgCrc32] !== undefined) {
    this.isPal = true;
  }

  // CHR-ROM, split into 4 KB banks. A count of zero means CHR-RAM, which is
  // filled by the PPU at reset.
  this.vrom = [];
  for (i = 0; i < this.vromCount; i++) {
    if (offset + 4096 <= bytes.length) {
      this.vrom.push(bytes.subarray(offset, offset + 4096));
      offset += 4096;
    } else {
      this.vrom.push(new Uint8Array(4096));
    }
  }

  // Pre-decode the CHR into tile objects so rendering never has to touch the
  // raw bytes.
  this.vromTile = [];
  for (v = 0; v < this.vromCount; v++) {
    var tiles = new Array(256);
    for (i = 0; i < 256; i++) {
      tiles[i] = new Tile();
    }

    for (i = 0; i < 4096; i++) {
      var tileIndex = i >> 4;
      var leftOver = i & 15;
      if (leftOver < 8) {
        tiles[tileIndex].setScanline(
          leftOver,
          this.vrom[v][i],
          this.vrom[v][i + 8],
        );
      } else {
        tiles[tileIndex].setScanline(
          leftOver - 8,
          this.vrom[v][i - 8],
          this.vrom[v][i],
        );
      }
    }

    this.vromTile[v] = tiles;
  }

  // A persistent save area, when the header asks for one. Upstream jsnes only
  // tracked a boolean, which made loadBatteryRam a no-op.
  this.batteryRamData = this.batteryRam ? new Uint8Array(0x2000) : null;

  this.valid = true;
};

if (typeof window !== "undefined") {
  window.jsnes = window.jsnes || {};
  window.jsnes.ROM = ROM;
  window.jsnes.MirroringTypes = MIRRORING_TYPES;
}

module.exports = ROM;
module.exports.ROM = ROM;
module.exports.MIRRORING_TYPES = MIRRORING_TYPES;
module.exports.MAPPER_NAMES = MAPPER_NAMES;
